import React, { useEffect, useState } from 'react';
import { Flame } from 'lucide-react';
export function CountdownTimer() {
  const [time, setTime] = useState({
    hours: 23,
    minutes: 58,
    seconds: 42
  });
  useEffect(() => {
    const interval = setInterval(() => {
      setTime(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        seconds -= 1;
        if (seconds < 0) {
          seconds = 59;
          minutes -= 1;
        }
        if (minutes < 0) {
          minutes = 59;
          hours -= 1;
        }
        if (hours < 0) {
          hours = 0;
          minutes = 0;
          seconds = 0;
          clearInterval(interval);
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const pad = (n: number) => String(n).padStart(2, '0');
  return <section id="elegir-plan" className="w-full bg-emerald-600 py-2 px-4 flex justify-center scroll-mt-4" data-id="element-29">
      <div className="w-full max-w-md flex items-center justify-center gap-2" data-id="element-30">
        <Flame className="w-3.5 h-3.5 text-yellow-300 flex-shrink-0" data-id="element-31" />
        <p className="text-white font-semibold text-xs" data-id="element-32">Oferta expira en</p>
        <div className="flex items-center gap-1 bg-white/15 rounded-md px-2 py-0.5" data-id="element-33">
          <span className="font-sans font-black text-white text-sm tabular-nums" data-id="element-34">
            {pad(time.hours)}
          </span>
          <span className="text-white/50 text-xs" data-id="element-35">:</span>
          <span className="font-sans font-black text-white text-sm tabular-nums" data-id="element-36">
            {pad(time.minutes)}
          </span>
          <span className="text-white/50 text-xs" data-id="element-37">:</span>
          <span className="font-sans font-black text-white text-sm tabular-nums" data-id="element-38">
            {pad(time.seconds)}
          </span>
        </div>
      </div>
    </section>;
}